import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModulesManagerService } from 'src/app/classes/Module/modules-manager.service';
import { Ask } from '../../classes/Ask/ask.service';
import { Field } from '../../classes/Field/field';
import { CreaPage } from 'src/app/crea/crea.page';
import { AskPage } from 'src/app/ask/ask.page';
import { States } from 'src/app/enums/States';
import { LoggerService } from '../../utils/logger.service';

@Component({
  selector: 'app-fields',
  templateUrl: './fields.component.html',
  styleUrls: ['./fields.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FieldsComponent implements OnInit {
  private currentAsk: Ask = null;
  interlocutorIsOpened = false
  public pandingRequest: boolean = false
  public targetEmail: string = ""
  public caller?: CreaPage | AskPage = null
  public fakeUser: any = {
    FirstName: "",
    LastName: "",
    Email: "",
  }
  private token: string = ""

  public get showModifMessage() {
    return this.currentAsk?.Modified
  }

  @ViewChild('confirmcontact') confirmContactAlert;
  @ViewChild('choosedocument') chooseDocumentAlert;
  @ViewChild('confirmdocument') confirmDocumentAlert;
  @ViewChild('confirmdeleteask') confirmDeleteAskAlert;
  @ViewChild('shares') shares;
  constructor(public manager: ModulesManagerService) { }


  get Token() {
    return this.token
  }

  set Token(value: string) {
    this.token = value
  }

  get DisplayValidateButton() {
    return this.CurrentAsk?.State == States.Creating && this.Token
  }

  get CurrentAsk(): Ask {
    return this.currentAsk
  }

  set CurrentAsk(value: Ask) {
    this.CurrentAsk?.Destroy()
    this.currentAsk = value
    this.manager.Tool.sleep(500).then(this.PostRender.bind(this))
  }

  get CreaPage(): CreaPage {
    return this.caller as CreaPage
  }
  get Structure(): Array<any> {
    return this.CurrentAsk?.Structure || []
  }


  private switchedAt = 0
  SwitchInterlocutorsState(event) {
    const now = Date.now()
    if (now - this.switchedAt < 100) return
    this.switchedAt = now
    event.stopPropagation()
    event.preventDefault()
    event.stopImmediatePropagation()
    this.interlocutorIsOpened = !this.interlocutorIsOpened

  }
  async PostRender() {
    if (!this.currentAsk) return
    // this.currentAsk?.Destroy();
    this.currentAsk?.postDisplayHtmlField(this.confirmDocumentAlert)

  }


  checkForImposedField() {

    if (!this.CurrentAsk?.checkForImposedField()) {
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_MISSING_IMPOSED_VALUE"))
      return false
    }
    return true

  }

  async sendAsk() {
    if (!this.manager.Ws.availableFeatures()) {
      return
    }
    if (!this.checkForImposedField()) return;
    this.pandingRequest = true;
    await this.manager.Tool.sleep(500)

    if (!(await this.manager.Usr.isAcceptedCgu())) {
      this.pandingRequest = false
      return false
    }
    let parsed = await this.parsed()
    let documents = []
    for (const field of parsed.askFieldData) {
      if (field.Type == "document") {
        for (const document of field.Value)
          documents.push(document)
        field.Value = []
      }
    }

    let answer: any = await this.manager.Ws.Send("Asks", "creaAsk", parsed, true).catch(e => LoggerService.error("FieldsComponent creaAsk error:", e))
    let navigate = false
    if (answer.Data.created) {
      let answer2: any = await this.manager.Ws.Send("Asks", "addDocumentFromCreation", { AskId: answer.Data.AskId, Documents: documents }, true).catch(e => LoggerService.error("FieldsComponent addDocumentFromCreation error:", e))
      if (answer2.success) {
        this.manager.Tool.notify(this.manager.Trad.Parse(answer2.success), "long")
        this.CurrentAsk?.Destroy()
        answer.Data.VerifyCode = answer2.Data.VerifyCode
      }
      await this.checkContact(answer).catch(e => LoggerService.error("FieldsComponent checkContact error:", e))
      if (!this.CreaPage?.createAccount)
        navigate = true
    }
    if (navigate)
      this.manager.Navi.navigateTo('asks')
    this.pandingRequest = false;
    return answer
  }

  async getExportedStructure(): Promise<Array<any>> {
    let structure: Array<any> = new Array<any>();
    for (const field of Object.values(this.Structure as Array<Field>))
      structure.push(await field.exportData())
    return structure
  }

  private async parsed() {
    this.fakeUser.Language = this.manager.Usr.LanguageUser
    this.fakeUser.Email = this.fakeUser.Email.toLowerCase()
    if (!this.manager.Usr.isLoged) {

      this.manager.Usr.EmailUser = this.fakeUser.Email.toLowerCase()
      this.manager.Usr.FirstNameUser = this.fakeUser.FirstName
      this.manager.Usr.LastNameUser = this.fakeUser.LastName
    }
    return {
      user: this.fakeUser,
      target: this.targetEmail,
      CreatedDate: this.CurrentAsk.displayField("CreatedDate"),
      askFieldData: await this.getExportedStructure(),
      InternalKey: this.CurrentAsk.InternalKey
    }
  }

  private async checkContact(answer: any) {
    if (this.manager.Usr.isLoged && answer.Data.newContactId > 0) {
      this.confirmContact(answer.Data.newContactId)
    }
  }


  public async deleteContact(contactId) {
    let resu = await this.manager.Ws.Send("UsersContacts", "delete", { Id: contactId }, true).catch(e => LoggerService.error("FieldsComponent deleteContact error:", e))
    if (resu.success) {
      this.manager.Tool.notify(this.manager.Trad.Parse(resu.success))
    }
  }

  public async editContact(contactId) {
    this.manager.Navi.navigateTo("/contacts", { id: contactId })
  }

  public async confirmContact(contactId) {
    this.confirmContactAlert.presentAlert({
      header: this.manager.Trad.Parse('STR_NEW_CONTACT'),
      message: this.manager.Trad.Parse('STR_NEW_CONTACT_DESCRIPTION'),
      cssClass: 'confirm-delete-alert',
      buttons: [
        {
          text: this.manager.Trad.Parse('STR_DELETE'),
          handler: () => { this.deleteContact(contactId) },
          cssClass: 'delete-button',
        },
        {
          text: this.manager.Trad.Parse('STR_EDIT'),
          handler: () => { this.editContact(contactId) },
          cssClass: 'edit-button',
        },
        {
          text: this.manager.Trad.Parse('STR_CLOSE'),
        },
      ],
    })
  }

  async ValidateMail() {
    let resu = await this.manager.Ws.Send("Mail", "VerifyCode", { Type: "Asks", Token: this.token }, true).catch(e => LoggerService.error("FieldsComponent ValidateMail error:", e))
    if (resu.success) {
      this.token = ""
      this.manager.Tool.notify(this.manager.Trad.Parse(resu.success))
    } else {
      this.manager.Tool.notify(this.manager.Trad.Parse(resu.error))
    }
  }


  public confirmeDeleteAsk() {
    this.confirmDeleteAskAlert.presentAlert({
      header: this.manager.Trad.Parse('STR_DELETE'),
      message: this.manager.Trad.Parse('STR_ASK_DELETE_CONFIRM'),
      cssClass: 'confirm-delete-alert',
      buttons: [
        {
          text: this.manager.Trad.Parse('STR_CANCEL'),
        },
        {
          text: this.manager.Trad.Parse('STR_DELETE'),
          handler: () => { this.CurrentAsk?.delete(); this.manager.Navi.navigateTo('asks') },
          cssClass: 'edit-button',
        },
      ],
    })
  }

  ngOnInit() { }

}
